<template>
    <b-modal
        v-model="modalPedidoProveedor"
        size="xl"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        
        <template v-slot:modal-title>
            <div class="pb-2">Confirmar Pedido a Proveedor</div>
        </template>
        <b-row>
            <b-table 
                responsive
                :fields="fields" 
                striped hover  
                :items="itemsProveedor">
                <template v-slot:cell(referencia)="data">
                    <b-row>
                        <b-col class="col-sm-2 d-none d-sm-block">
                            <b-img :src="data.item.imagen" :alt="data.item.imagen" style="max-width: 100%; max-height: 150px; object-fit: scale-down;"></b-img>
                        </b-col>
                        <b-col cols="12" md="9">
                            <div>
                                {{ data.item.nombre }}
                            </div>
                            <div>
                                <b>Item:</b> {{ data.item.referencia }}
                            </div>
                            <div>
                                <b-button pill variant="danger" size="sm" 
                                    @click.prevent="$emit('remove-item-to-proveedor', data.index, itemsProveedor)">
                                    <b-icon icon="trash"></b-icon>
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <template v-slot:cell(cantidad)="data">
                    <b-form-input type="number" min="1" oninput="validity.valid||(value='');" 
                        v-model="data.item.cantidad" 
                        @change="$emit('compare-available-amount', data.item, itemsProveedor)">
                    </b-form-input>
                    <b-badge pill variant="danger" v-if="data.item.no_stock > 0">No hay stock</b-badge>
                    <b-badge pill variant="danger" v-if="data.item.no_stock === 0 && data.item.cantidad > data.item.existencia">Solo disponemos de {{ data.item.existencia }} unidades</b-badge>
                    
                </template>
                <template v-slot:cell(precio_sin_imp)="data">
                    $ {{numberFormat(data.item.precio_sin_imp)}}
                </template>
                <template v-slot:cell(porcentaje_impuesto)="data">
                    {{data.item.porcentaje_impuesto}} %
                </template>
                <template v-slot:cell(subtotal_items_cantidad_imp)="data">
                    $ {{ numberFormat(data.item.subtotal_items_cantidad_imp) }}
                </template>
            </b-table>
        </b-row>
        <hr>
        <b-row align-h="between">
            <b-col cols="12" md="6">
                <div class="pb-4"><b>Comentario de la Orden:</b></div>
                <div>
                    <b-button variant="info" @click.prevent="$emit('open-modal-order-comment')">
                        <b-icon icon="trash"></b-icon> Añadir comentario
                    </b-button>
                </div>
                <div v-if="comentario !== null" class="pt-3">
                    <div><b>Comentario:</b></div>
                    <div>{{comentario}}</div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <th class="text-end">Subtotal Bruto:</th>
                            <td><b>$ {{numberFormat(liquidacionProveedor.subtotal_bruto)}}</b></td>
                        </tr>
                        <tr v-if="liquidacionProveedor.descuento_comercial > 0">
                            <th class="text-end">Descuento:</th>
                            <td><b>$ {{numberFormat(liquidacionProveedor.descuento_comercial)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">Subtotal Neto:</th>
                            <td><b>$ {{numberFormat(liquidacionProveedor.subtotal_neto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end">IVA:</th>
                            <td><b>$ {{numberFormat(liquidacionProveedor.impuesto)}}</b></td>
                        </tr>
                        <tr>
                            <th class="text-end blue--text">Monto Total:</th>
                            <td class="blue--text"><b>$ {{numberFormat(liquidacionProveedor.total_precio)}}</b></td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
        <b-row align-h="between">
            <b-col cols="6" md="6" >
                <b-form-checkbox v-model="servicioLogisticoLocal" switch>
                    Servicio Logistico
                </b-form-checkbox>
                <b-badge variant="danger" v-if="disableProcess">{{notLogisticServiceMessage}}</b-badge>
            </b-col>
            <b-col cols="6" md="6" v-if="itemsNoAvailable.length > 0">
                <b-badge variant="danger">Los siguientes artículo ya no estan disponibles y fueron removidos</b-badge>
                <b-container>
                    <ul>
                        <li v-for="(item, index) in itemsNoAvailable" :key="index">{{item}}</li>
                    </ul>
                </b-container>
            </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
            </b-button>
            <b-button :disabled="disableProcess" variant="success" @click.prevent="$emit('store-pedido-proveedor', itemsProveedor, datos)">
                Realizar Pedido
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "RequestOrder",
    props: {
        itemsProveedor: {
            type: Array
        },
        liquidacionProveedor: {
            type: Object
        },
        modalPedidoProveedor: {
            type: Boolean
        },
        comentario: {
            type: String
        },
        disableProcess: {
            type: Boolean
        },
        datos: {
            type: Object
        },
        servicioLogistico: {
            type: Boolean
        },
        notLogisticServiceMessage: {
            type: String
        },
        itemsNoAvailable:{
            type: Array
        }
    },
    model: {
        prop: 'servicioLogistico',
        event: 'servicio-logistico-change'
    },
    computed: {
        servicioLogisticoLocal: {
            get: function() {
                return this.servicioLogistico
            },
            set: function(value) {
                this.$emit('servicio-logistico-change', value, this.itemsProveedor)
            }
        }
    },
    data(){
        return{
            fields: [
                { key: 'referencia', label: 'Item', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'precio_sin_imp', label: 'Vr. Unit', sortable: true},
                { key: 'porcentaje_impuesto', label: 'Impuesto', sortable: true},
                { key: 'subtotal_items_cantidad_imp', label: 'Subtotal', sortable: true},
            ],
        }
    },
};

</script>
<style scoped>

</style>